module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nft4-ce90db01287aea893c2ec03b80bd3c73.png";